import { HOST } from "./secret";

const API = {

  sign: {

    in: `${ HOST }/signin`,
    check: `${ HOST }/check`,

  },

  statistic: {

    users: `${ HOST }/admin/statistic/users`,
    buys_for_users: `${ HOST }/admin/statistic/buys-for-users`,

  },

  // file: {

  //   upload: `${ HOST }/upload-file`,

  // }

}

export default API;